import { IItemEscopo } from '../../../../hooks/useEventoContrato';

/**
 * "R$ 7.150,00" -> 7150. Sem número reconhecível: null. A MESMA regra do gate
 * (`gate_contrato.em_reais`): ponto só é decimal sem vírgula e sem grupo de
 * milhar — "7150.00" é 7150 (virava 715000) e "R$ 36.900" é 36900.
 */
export function emReais(v?: string | null): number | null {
  let s = (v ?? '').replace(/[^\d,.]/g, '');
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, '');
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : null;
}

export const brl = (n: number) => n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

/**
 * A soma dos itens contra o valor total da ficha — a mesma conta que o gate faz
 * na geração, só que ao vivo, enquanto o operador mexe na tabela.
 */
export function somaDoEscopo(itens: IItemEscopo[], valorTotal?: string | null) {
  const soma = itens.reduce((acc, it) => acc + (emReais(it.valor) ?? 0), 0);
  const total = emReais(valorTotal);
  return { soma, total, bate: total !== null && Math.abs(soma - total) < 0.01 };
}
